import { render, staticRenderFns } from "./AdminSettingsMenu.vue?vue&type=template&id=7cd1769d&scoped=true&"
import script from "./AdminSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./AdminSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingsMenu.vue?vue&type=style&index=0&id=7cd1769d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd1769d",
  null
  
)

export default component.exports